import { useMemo, useState } from "react";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import useFlightsSearch from "../../hooks/useFlightsSearch";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { applyFilter, applySorter, groupBy, explode } from "src/utility";
import { SorterType, ALL_FILTERS, GROUP_OPTIONS, } from "../../constants";
import { transformFormToFilters, transformFormToSorters } from "./utils";
import  JourneyListingProvider from "./context/JourneyListingContext";
import JourneyListingWeb from "./layouts/JourneyListing.web";
import JourneyListingMobile from "./layouts/JourneyListing.mobile";
import { ALL_SORTERS, JourneyFilterType } from "../../constants/JourneyListing";
import { Navigate } from "react-router-dom";

const JourneyListingComponent = withConditionalComponent(JourneyListingWeb, JourneyListingMobile);

export default function JourneyListing() {
  const { responseObject, searchObject,notFound } = useFlightsSearch();
  
  const {data:fullResponse, isFetching}  = explode(responseObject,{});
  const journeys = fullResponse?.journeys ?? [];
  const filtersState = useState<JourneyFilterType>({});
  const sorterState = useState<SorterType>({});
  const [sorter] = sorterState;
  const [filters] = filtersState;

  const filteredData = journeys?.filter(
    applyFilter(
      ALL_FILTERS,
      transformFormToFilters(filters),
    ),
  );
  const journies = applySorter(ALL_SORTERS, transformFormToSorters(sorter))(filteredData);
  const fullDataGroups = useMemo(() => groupBy(journeys, GROUP_OPTIONS), [journeys, GROUP_OPTIONS]);
  const filteredGroups = groupBy(filteredData , GROUP_OPTIONS);
  const dataCount = { segmentCount: filteredData.length, totalCount: journeys.length};

  const contextValue = useMemo(() => ({ filtersState, sorterState, searchObject, dataCount, isFetching }), [filters, sorter, searchObject, dataCount, isFetching]);
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];

  if (notFound) return <Navigate to="/not-found"/>

  return (
    <JourneyListingProvider value={contextValue}>
      <JourneyListingComponent
        trigger={isLargeScreen}
        props={{
          filteredGroups,
          fullDataGroups,
          journies,
        }}
      />
    </JourneyListingProvider>
  );
}
